import React from "react";

import { BulkImportRequestFragmentFragment } from "~/components/Admin/User/BulkImport/BulkImport.generated";
import { PrimaryButton, SecondaryButton } from "~/components/common/buttons";

interface Props {
  orgSlug: string;
  request: BulkImportRequestFragmentFragment;
  onOpenQaDialog?: () => void;
  onClose: () => void;
}

export const DoneStep = ({
  orgSlug,
  request,
  onOpenQaDialog,
  onClose,
}: Props) => {
  const exportUrl = `/cleancapital/admin/${orgSlug}/bulk-imports/${request.id}/export.xlsx`;

  return (
    <div className="text-center py-4">
      <h5 className="mb-3" style={{ color: "#495057" }}>
        Import Complete
      </h5>
      <p style={{ color: "#666" }}>
        {request.rowCounts.newUser} new user
        {request.rowCounts.newUser !== 1 ? "s" : ""} invited
        {request.rowCounts.existingUserNewGroup > 0 && (
          <>, {request.rowCounts.existingUserNewGroup} added to new groups</>
        )}
        .
      </p>
      <div
        className="d-flex align-items-center justify-content-center mt-4"
        style={{ gap: "0.75rem" }}
      >
        <a href={exportUrl} download style={{ textDecoration: "none" }}>
          <SecondaryButton as="span">
            <i
              className="thumbnail icon icon--download"
              style={{ width: 14, height: 14, marginRight: 6, marginBottom: 2 }}
            />
            Download export (.xlsx)
          </SecondaryButton>
        </a>
        {onOpenQaDialog && (
          <PrimaryButton onClick={onOpenQaDialog}>
            Create Q&amp;A logs
          </PrimaryButton>
        )}
        <SecondaryButton onClick={onClose}>Close</SecondaryButton>
      </div>
    </div>
  );
};
